module.exports = __webpack_public_path__ + "static/media/kubernates.6a347940.png";